import type { ApiResponse } from '@bower/shared';
import type { HttpClient } from './http-client.types';

export function acceptInvitationById(http: HttpClient, invitationId: string) {
  return http.post<{ workspaceId: string | null; invitationId: string }>(
    `/invitations/${invitationId}/accept`,
    {},
  );
}

export function getPendingInvitations(http: HttpClient) {
  return http.get<
    Array<{
      id: string;
      email: string;
      workspaceId: string | null;
      workspace: { id: string; name: string; slug: string } | null;
      inviter: { id: string; name: string | null } | null;
      intendedRole: string;
      expiresAt: string;
      createdAt: string;
    }>
  >('/invitations/pending');
}

export function updateLastLoggedInWorkspace(
  http: HttpClient,
  workspaceId: string,
): Promise<ApiResponse<{ lastLoggedInWorkspace: string }>> {
  return http.post('/auth/update-last-workspace', { workspaceId });
}
